<script>
  export let dates;

  import { format } from "./dates.mjs";
</script>

<ul>
  {#each dates as day}
    <li>
      {format(day)}
    </li>
  {/each}
</ul>

<style>
  ul {
    list-style: none;
    padding-left: 0;
  }

  li {
    list-style: none;
    margin-bottom: 1em;
  }
</style>
